export const userInitialState = {
    loggedUserData: null,
    userList: [],
};